import ReactDOMServer from 'react-dom/server'

export const getIconUrl = (icon: React.ReactElement) =>
  'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(ReactDOMServer.renderToStaticMarkup(icon))
